/**
 * Runtime configuration — reads from window.__APP_CONFIG__ set by config.js.
 * Generated at build/dev time by scripts/generate-config.mjs.
 */
export var config = window.__APP_CONFIG__ || {};
